import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { Store } from "../../../@core/store/store";
import { addToRecentlyAccessedLoadedState, addToRecentlyAccessedLoadingErrorState, addToRecentlyAccessedLoadingState, GetAllCategoriesLoadedState, GetAllCategoriesLoadingErrorState, GetAllCategoriesLoadingState, pinAppLoadedState, pinAppLoadingErrorState, pinAppLoadingState, profileDataLoadedState, profileDataLoadingErrorState, profileDataLoadingState, UnPinAppLoadedState, UnPinAppLoadingErrorState, UnPinAppLoadingState } from "./applications.state";
import { environment } from "../../../../environments/environment";
import { CATEGORIES } from "./applications.data";


@Injectable({
    providedIn: 'root'
})

export class ApplicationService extends Store.AbstractService {
    getAllApplications(reqBody): any {
        const me = this;
        const output = new Subject<Store.State>();

        setTimeout(() => {
            output.next(new GetAllCategoriesLoadingState());
        }, 0);

        // setTimeout(() => {
        //     output.next(new GetAllCategoriesLoadedState(CATEGORIES))
        //     output.complete();
        // }, 2000);

        // return output;

        const path = environment.api.applications.getAllApplications.endpoint;
        me.controller.post(path, reqBody, undefined, { Authorization: true }).subscribe(
            (data: any) => {
                output.next(new GetAllCategoriesLoadedState(data));
                output.complete();
            },
            (e: any) => {
                output.error(new GetAllCategoriesLoadingErrorState(e));
                output.complete();
            }
        );
        return output;
    }


    pinApp(reqBody): any {
        const me = this;
        const output = new Subject<Store.State>();

        setTimeout(() => {
            output.next(new pinAppLoadingState());
        }, 0);



        const path = environment.api.applications.addToFavourite.endpoint;
        me.controller.post(path, reqBody, undefined, { Authorization: true }).subscribe(
            (data: any) => {
                output.next(new pinAppLoadedState(data));
                output.complete();
            },
            (e: any) => {
                output.error(new pinAppLoadingErrorState(e));
                output.complete();
            }
        );
        return output;
    }

    unPinApp(reqBody): any {
        const me = this;
        const output = new Subject<Store.State>();

        setTimeout(() => {
            output.next(new UnPinAppLoadingState());
        }, 0);



        const path = environment.api.applications.removeFromFavourite.endpoint;
        me.controller.post(path, reqBody, undefined, { Authorization: true }).subscribe(
            (data: any) => {
                output.next(new UnPinAppLoadedState(data));
                output.complete();
            },
            (e: any) => {
                output.error(new UnPinAppLoadingErrorState(e));
                output.complete();
            }
        );
        return output;
    }


addRecentlyAccessedApp(reqBody): any {
    const me = this;
    const output = new Subject<Store.State>();

    setTimeout(() => {
        output.next(new addToRecentlyAccessedLoadingState());
    }, 0);



    const path = environment.api.applications.addToRecentlyAccessed.endpoint;
    me.controller.post(path, reqBody, undefined, { Authorization: true }).subscribe(
        (data: any) => {
            output.next(new addToRecentlyAccessedLoadedState(data));
            output.complete();
        },
        (e: any) => {
            output.error(new addToRecentlyAccessedLoadingErrorState(e));
            output.complete();
        }
    );
    return output;
}

fetchProfileData(empId) {
    const me = this;
    const output = new Subject<Store.State>();
    setTimeout(() => {
      output.next(new profileDataLoadingState());
    }, 0);

    const path = me.controller.replaceVariables(
      environment.api.profile.userProfile.endpoint,
      { empId }
    );

    me.controller.get(path, null, undefined, { Authorization: true }).subscribe(
      (data: any) => {
        output.next(new profileDataLoadedState(data));
        output.complete();
      },
      (e: any) => {
        output.error(new profileDataLoadingErrorState(e));
        output.complete();
      }
    );
    return output;
  }

}




